import { render, staticRenderFns } from "./BodyPresetGrid.vue?vue&type=template&id=db8e4d10&scoped=true"
import script from "./BodyPresetGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./BodyPresetGrid.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BodyPresetGrid.vue?vue&type=style&index=0&id=db8e4d10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8e4d10",
  null
  
)

export default component.exports